import { useState, useEffect } from 'react';
import noProfileImage from '../../../public/assets/no-profile-image.png';

const useImageLoader = (imageUrl: string) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [error, setError] = useState(false);

  const handleNoImage = () => {
    setError(true);
    setImageLoaded(true);
  };

  useEffect(() => {
    if (imageUrl) {
      const img = new Image();
      img.src = imageUrl;

      setImageLoaded(false);
      setError(false);

      const onLoad = () => {
        setImageLoaded(true);
      };

      const onError = () => {
        handleNoImage();
      };

      img.onload = onLoad;
      img.onerror = onError;

      // Cleanup function to remove event listeners
      return () => {
        img.onload = null;
        img.onerror = null;
      };
    } else {
      handleNoImage();
    }
  }, [imageUrl]);

  return { imageLoaded, noProfileImage, error };
};

export default useImageLoader;
